import React from 'react';
import { IconProps } from './types';

const ViewIcon: React.FC<IconProps> = props => {
  const { className, size = 16, onClick, fillColor = '#969696' } = props;
  return (
    <svg
      onClick={onClick}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_12577_140153"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={size}
        height={size}
      >
        <rect width={size} height={size} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_12577_140153)">
        <path
          d="M8.00033 10.668C8.83366 10.668 9.5421 10.3764 10.1257 9.7933C10.7088 9.20975 11.0003 8.5013 11.0003 7.66797C11.0003 6.83464 10.7088 6.12619 10.1257 5.54264C9.5421 4.95952 8.83366 4.66797 8.00033 4.66797C7.16699 4.66797 6.45855 4.95952 5.87499 5.54264C5.29188 6.12619 5.00033 6.83464 5.00033 7.66797C5.00033 8.5013 5.29188 9.20975 5.87499 9.7933C6.45855 10.3764 7.16699 10.668 8.00033 10.668ZM8.00033 9.46797C7.50033 9.46797 7.07544 9.29286 6.72566 8.94264C6.37544 8.59286 6.20033 8.16797 6.20033 7.66797C6.20033 7.16797 6.37544 6.74286 6.72566 6.39264C7.07544 6.04286 7.50033 5.86797 8.00033 5.86797C8.50033 5.86797 8.92544 6.04286 9.27566 6.39264C9.62544 6.74286 9.80032 7.16797 9.80032 7.66797C9.80032 8.16797 9.62544 8.59286 9.27566 8.94264C8.92544 9.29286 8.50033 9.46797 8.00033 9.46797ZM8.00033 12.668C6.3781 12.668 4.90033 12.2151 3.56699 11.3093C2.23366 10.404 1.26699 9.19019 0.666992 7.66797C1.26699 6.14575 2.23366 4.93175 3.56699 4.02597C4.90033 3.12064 6.3781 2.66797 8.00033 2.66797C9.62255 2.66797 11.1003 3.12064 12.4337 4.02597C13.767 4.93175 14.7337 6.14575 15.3337 7.66797C14.7337 9.19019 13.767 10.404 12.4337 11.3093C11.1003 12.2151 9.62255 12.668 8.00033 12.668ZM8.00033 11.3346C9.25588 11.3346 10.4088 11.004 11.459 10.3426C12.5088 9.68175 13.3114 8.79019 13.867 7.66797C13.3114 6.54575 12.5088 5.65397 11.459 4.99264C10.4088 4.33175 9.25588 4.0013 8.00033 4.0013C6.74477 4.0013 5.59188 4.33175 4.54166 4.99264C3.49188 5.65397 2.68921 6.54575 2.13366 7.66797C2.68921 8.79019 3.49188 9.68175 4.54166 10.3426C5.59188 11.004 6.74477 11.3346 8.00033 11.3346Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default ViewIcon;
